import jade from 'javascripts/core_post_webpack/sitewide_business_elements/modals/templates/confirm_modal.jst.jade';
window.JST = window.JST || {};
window.JST[
  'core_post_webpack/sitewide_business_elements/modals/templates/confirm_modal'
] = jade;
